import { useRouteError, isRouteErrorResponse } from "react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ErrorImage from "@/assets/images/errors/error.svg";
import NotFound from "./not-found";
import { COOKIE_SID } from "@/constants/normal";
import Cookies from "js-cookie";

function ErrorRoute() {
  const error = useRouteError();
  const { t } = useTranslation();
  const sid = Cookies.get(COOKIE_SID) || "";

  const [isRouterError, setIsRouterError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!error) return;

    let message = "";

    if (isRouteErrorResponse(error)) {
      setIsRouterError(true);
    } else if (error instanceof Error) {
      message = error.message;
    }

    setErrorMessage(message);
  }, [error]);

  const refreshPage = () => {
    window.location.reload();
  };

  const goHome = () => {
    window.location.href = "/";
  };

  if (isRouterError) {
    return <NotFound goHome={goHome} />;
  }

  return (
    <div className="bg-metal-100 font-noto-sans container mx-auto flex h-screen flex-col items-center justify-center gap-4 p-4">
      <div className="flex-center flex flex-col gap-4">
        <img src={ErrorImage} alt="not found" width={160} height={160} className="object-contain" />

        <div className="mt-2 flex w-[320px] flex-col items-center justify-center gap-4">
          <p className="font-noto-sans text-metal-700 desktop:text-base mobile:text-sm line-clamp-2 leading-normal text-wrap break-all">
            ClientID {sid}
          </p>

          <p className="font-noto-sans text-metal-700 desktop:text-base mobile:text-sm line-clamp-3 text-center leading-normal text-wrap break-all">
            {errorMessage || "error"}
          </p>
        </div>

        <div className="flex gap-4">
          <button
            className="bg-primary-500 font-noto-sans text-neutral-0 flex-center flex h-10 gap-2 rounded-lg px-4 py-2 text-base"
            onClick={refreshPage}>
            {t("NORMAL.REFRESH")}
          </button>

          <button
            className="font-noto-sans bg-primary-500 text-neutral-0 flex-center flex h-10 gap-2 rounded-lg px-4 py-2 text-base"
            onClick={goHome}>
            {t("ERROR.404.GO_HOME")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorRoute;
